export default __webpack_public_path__ + "media/color/enj-26848a34.svg";